// Imports
// ------
import React from 'react';
import styled from 'styled-components';
import { ExtLink } from '@reuse';
import { breakup } from '@break';

// Styles
// ------
const Jacket = styled.ul`
    text-align: left;
    list-style: none;
    position: relative;
    padding-left: ${props => props.theme.mpad};

    ${breakup.large`
        padding-left: 0;
        text-align: right;
    `}
`;

const SocialLink = styled.li`
    display: block;
    margin: 2.4rem 0;

    ${breakup.large` margin: 0 0 6rem 0; `}

    &:last-child {
        margin-bottom: 0;
    }

    > a {
        color: white;

        &:hover {
            color: white;
            opacity: 0.5;
        }
    }
`;

// Components
// ------
export default class Social extends React.PureComponent {
    render() {
        return (
            <Jacket>
                {
                    this.props.facebook &&
                    <SocialLink>
                        <ExtLink href={this.props.facebook} target="_blank">Facebook</ExtLink>
                    </SocialLink>
                }

                { 
                    this.props.twitter &&
                    <SocialLink>
                        <ExtLink href={this.props.twitter} target="_blank">Twitter</ExtLink>
                    </SocialLink>
                }

                {
                    this.props.linkedin &&
                    <SocialLink>
                        <ExtLink href={this.props.linkedin} target="_blank">LinkedIn</ExtLink>
                    </SocialLink>
                }
            </Jacket>
        );
    }
}